import { BsCloud, BsCloudRain } from "react-icons/bs";
import { FiBatteryCharging, FiWind } from "react-icons/fi";
import { MdImportExport, MdOutlineUploadFile } from "react-icons/md";
import { RiRemoteControlLine } from "react-icons/ri";
import { TbActivity, TbAlertCircle, TbCircleCheck, TbCircleDotted, TbCloudNetwork, TbDatabase, TbDeviceAirpodsCase, TbLineHeight, TbTemperature } from "react-icons/tb";
import SignalQualityIcon from "src/hci/other/SignalQualityIcon";
import { MeasurementSystem, MeasurementType } from "src/helper/constants";
import useMeasurement from "src/helper/useMeasurement";
import { DjiCloudDrcState, DjiCloudNetworkType, DjiDockModeText } from "src/services/device/common/deviceConstants";
import prettyBytes from 'pretty-bytes';

export const dockTelemetryItems = (telemetries) => {
  const { convertValue, getMeasurementUnit, measurementSystem } = useMeasurement();

  return [
    {
      title: 'Rain',
      value: {0:"No rain", 1:"Light rain", 2:"Moderate rain", 3:"Heavy rain"}[telemetries?.rainfall ?? '0'],
      icon: telemetries?.rainfall ? <BsCloudRain /> : <BsCloud />
    },
    {
      title: 'Cover',
      value: {0:"Cover Closed", 1:"Cover Open", 2:"Cover Busy", 3:"Cover Abnormal"}[telemetries?.cover_state ?? '0'],
      icon: <TbDeviceAirpodsCase />
    },
    {
      title: 'Wind',
      value: `${Number(convertValue(telemetries?.wind_speed, MeasurementType.SPEED, MeasurementSystem.METRIC)).toFixed(1) ?? '-'} ${getMeasurementUnit(MeasurementType.SPEED)}`,
      icon: <FiWind />
    },
    {
      title: 'Height (ellipsoid)',
      value: `${Number(convertValue(telemetries?.height, MeasurementType.ALTITUDE, MeasurementSystem.METRIC)).toFixed(1) ?? '-'} ${getMeasurementUnit(MeasurementType.ALTITUDE)}`,
      icon: <TbLineHeight />
    },
    {
      title: 'Temperature',
      value: `${Number(convertValue(telemetries?.environment_temperature, MeasurementType.TEMPERATURE, MeasurementSystem.METRIC)) ?? '-'}${getMeasurementUnit(MeasurementType.TEMPERATURE)}`,
      icon: <TbTemperature />
    },
    {
      title: 'Upload Queue',
      value: `${telemetries?.media_file_detail?.remain_upload ?? '-'}`,
      icon: <MdOutlineUploadFile />
    },
    {
      title: 'Drone Battery Charge',
      value: `${telemetries?.drone_charge_state?.capacity_percent ?? '-'} %`,
      icon: <FiBatteryCharging />
    },
    ...(
      telemetries?.network_state?.type === DjiCloudNetworkType.LTE ? [
        {
          title: `4G Signal ${telemetries?.wireless_link?.['4g_gnd_quality'] * 20}`,
          value: '4G',
          icon: <SignalQualityIcon quality={telemetries?.wireless_link?.['4g_gnd_quality']} />
        },
      ] : []
    ),
    {
      title: 'Network Rate',
      value: `${telemetries?.network_state?.rate?.toFixed(1) ?? '-'} KB/s`,
      icon: <MdImportExport />
    },
    ...(
      telemetries?.storage?.total ? [
        {
          title: 'Storage status',
          value: `${prettyBytes(telemetries?.storage?.total * 1024 )} (${Math.ceil((telemetries?.storage?.used / telemetries?.storage?.total) * 100)}% used)`, // Kilobytes to bytes
          icon: <TbDatabase />
        }
      ] : []
    ),
    {
      title: 'Drone In Dock',
      value: `${telemetries?.drone_in_dock ? 'Drone In Dock' : 'Drone Not In Dock'}`,
      icon: telemetries?.drone_in_dock ? <TbCircleCheck /> : <TbCircleDotted />
    },
    {
      title: 'DRC Status',
      value:  telemetries?.drc_state === DjiCloudDrcState.ENABLED ? 'DRC Enabled' : telemetries?.drc_state === DjiCloudDrcState.REQUESTED ? 'DRC Requested' : 'DRC Disabled',
      icon: <RiRemoteControlLine />
    },
    {
      title: 'Operation Mode',
      value: `${DjiDockModeText[telemetries?.mode_code] ?? '-'}`,
      icon: <TbActivity />
    },
  ];
}